import React, { useEffect, useContext, useState, cloneElement } from 'react';
import clsx from 'clsx';

import {
    Avatar
} from '@material-ui/core';

import Skeleton from '@material-ui/lab/Skeleton';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {},
    avatar: {
    }
}));

export const AvatarSkeleton = ({
    variant,
    width,
    height,
    src,
    ...props }) => {
    const classes = useStyles();

    const [isReady, setIsReady] = useState(true);
    const loadAvatarImageHandler = () => {
        setIsReady(true);
    }

    const errorImageHandler = () => {
        setIsReady(true);
    }

    useEffect(() => {
        if (src) setIsReady(false);
    }, [src])

    return (
        <div className={clsx(classes.root, props.className)}>
            {!isReady &&
                <Skeleton variant={variant} width={width} height={height} />
            }
            {cloneElement(props.children, {
                src: src,
                hidden: !isReady,
                imgProps: {
                    onLoad: loadAvatarImageHandler,
                    onError: errorImageHandler
                },
                style: {
                    height: !isReady && height ? "0px" : height,
                    width: !isReady && width ? "0px" : width,
                }
            })}
        </div>
    );
}